import TenderList from "./tenderList";

function App() {
  return (
    <div style={{ padding: 20 }}>
      <TenderList />
    </div>
  );
}

export default App;
